var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButterfly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7087 3.07478C14.773 2.18778 11.2985 5.73548 10.3412 8.49053C8.55542 13.6296 9.92087 17.6788 10.1193 18.4374C10.3178 19.196 11.6087 23.1587 14.9034 22.4847C18.3329 21.7831 17.7607 18.1745 17.1875 17.5111C16.5113 16.7286 15.8824 15.275 18.1543 14.7291C21.2384 13.9879 23.646 11.9599 24.4599 10.4368C25.8256 7.88131 23.8022 3.81041 19.7087 3.07478Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19073 0.874559C10.7976 2.09932 10.9663 6.15169 10.0835 8.40303C8.78769 11.7075 6.33769 12.9837 5.10502 13.7264C4.1166 14.3219 1.79211 15.064 0.734931 13.4089C-0.427489 11.5891 0.861007 10.117 2.06654 9.83584C2.72958 9.68122 3.77425 9.57774 2.93122 7.98635C2.15813 6.52701 1.47555 4.41428 1.73623 3.18792C1.82799 2.75624 2.93486 -0.570572 7.19073 0.874559Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterfly);
export default __webpack_public_path__ + "static/media/butterfly.baea828b094c94f7fbcdb4086cc44830.svg";
export { ForwardRef as ReactComponent };